interface LogoProps {
  size?: number
  className?: string
}

/**
 * Marca de Nexo: tres nodos conectados (un "nexo"/punto de union), con el
 * nodo superior en el color de acento para que combine con el wordmark
 * "ne[x]o" donde la X ya lleva ese mismo color.
 */
export function Logo({ size = 22, className }: LogoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} role="img" aria-label="Nexo">
      <path
        d="M12 7.6 L6.3 15.1 M12 7.6 L17.7 15.1 M7.5 17 H16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="12" cy="5.2" r="2.4" className="fill-accent" />
      <circle cx="5.2" cy="17" r="2.4" fill="currentColor" />
      <circle cx="18.8" cy="17" r="2.4" fill="currentColor" />
    </svg>
  )
}
